export default "__VITE_ASSET__C02bZw_q__"